import React from "react";
import {
  Tabs,
  Tab,
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
  OutlinedInput,
} from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";
import { Link } from "react-router-dom";
import ActivityBar from "../../components/Reusable/ActivityBar/ActivityBar";

const tabList = [
  "Johannesburg, BSC",
  "Xiamen, BSC",
  "Quilmes, BSC",
  "Aguascalientes, BSC",
  "NAZ, BSC",
  "Jaguariuna, BSC",
  "Prague & India GCC",
];

const filterOptions = ["2025", "2024"];
const allOptions = ["All", "2025", "2024"];

const DashboardSelect = ({
  label,
  id,
  options,
}: {
  label: string;
  id: string;
  options: string[];
}) => {
  const [selectedValues, setSelectedValues] = React.useState<string[]>([]);

  const handleChange = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectedValues(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <FormControl fullWidth>
      <Box sx={{ fontSize: "14px", marginBottom: "6px", fontWeight: 500 }}>{label}</Box>
      <Select
        id={id}
        multiple
        displayEmpty
        value={selectedValues}
        onChange={handleChange}
        input={<OutlinedInput />}
        renderValue={(selected) =>
          selected.length === 0 ? <span style={{ color: "#999" }}>Select</span> : selected.join(", ")
        }
        sx={{
          '& .MuiSelect-select': {
            padding: '10px',
            color: '#000',
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            <Checkbox checked={selectedValues.indexOf(option) > -1} />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

function createData(
  name: string,
  calories: string,
  fat: string,
  carbs: string,
  protein: string,
  additionalProtein: string,
  score: string,
  KPICalculation:string,
) {
  return { name, calories, fat, carbs, protein, additionalProtein, score, KPICalculation };
}

const rows = [
  createData(
    "Results",
    "Finance",
    "E2E KPIS - OTC",
    "GLOBAL OTC ZERO TOLERANCE ",
    "FSI",
    "Mexico",
    "<=LY (4.4%) or <=4% ",
    "May YTD Value = 19.79% - Not Achieved",

  ),
  createData(
    "Results",
    "Finance",
    "E2E KPIS - OTC",
    "GLOBAL OTC ZERO TOLERANCE ",
    "FSI",
    "Mexico",
    "<=LY (4.4%) or <=4% ",
    "May YTD Value = 19.79% - Not Achieved",

  ),
]
 

const ResultDeepdive: React.FC = () => {
  const [selectedTab, setSelectedTab] = React.useState("Johannesburg, BSC");

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue);
  };

  const breadcrumbs = [
    <Link key="1" color="#000" to="/">
      Home
    </Link>,
    <Link key="2" color="#000" to="/">
      Deep-Dive
    </Link>,
  ];

  return (
    <>
      <ActivityBar breadcrumbs={breadcrumbs} />

      <TabContext value={selectedTab}>
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            borderBottom: 1,
            borderColor: "divider",
            mx: 2,
            backgroundColor: "#fff",
            borderRadius: 1,
          }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontFamily: "Avantt",
                color: "#666",
                "&.Mui-selected": {
                  color: "#000",
                  fontWeight: 600,
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#D7A833",
                height: 3,
              },
            }}
          >
            {tabList.map((label) => (
              <Tab key={label} label={label} value={label} />
            ))}
          </Tabs>
        </Box>

        {tabList.map((label) => (
          <TabPanel key={label} value={label} sx={{ padding: "10px !important" }}>
            <Paper sx={{ p: 2, mb: 2 }}>
              <Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                <Box sx={{ width: "20%" }}>
                  <DashboardSelect id="year" label="Star Block" options={filterOptions} />
                </Box>
                <Box sx={{ width: "20%" }}>
                  <DashboardSelect id="half" label="L2 Description" options={filterOptions} />
                </Box>
                <Box sx={{ width: "20%" }}>
                  <DashboardSelect id="type" label="L3 Description" options={allOptions} />
                </Box>
                <Box sx={{ width: "20%" }}>
                  <DashboardSelect id="star" label="Audit Requirements" options={allOptions} />
                </Box>
              </Box>
            </Paper>

            <TableContainer>
              <Table sx={{ minWidth: 650, borderCollapse: "collapse", marginTop: "20px" }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#000" }}>
                    {[
                      "Star Block",
                      "L2 Description",
                      "L3 Description",
                      "Audit Requirements",
                      "Source",
                      "Scope",
                      "Target",
                      "KPI Calculation",
                    
                    ].map((col, index) => (
                      <TableCell
                        key={index}
                        align={index === 0 ? "left" : "center"}
                        sx={{
                          color: "#fff",
                          border: "none",
                        }}
                      >
                        {col}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, i) => (
                    <TableRow
                      key={i}
                      sx={{
                        "& td, & th": {
                          color: "#000",
                          fontSize: "14px",
                          fontWeight: 600,
                          border: "none",
                          borderBottom: "1px solid #000",
                        },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="center">{row.calories}</TableCell>
                      <TableCell align="center">{row.fat}</TableCell>
                      <TableCell align="center">{row.carbs}</TableCell>
                      <TableCell align="center">{row.protein}</TableCell>
                      <TableCell align="center">{row.additionalProtein}</TableCell>
                      <TableCell align="center">
                        {row.score}
                      </TableCell>
                      <TableCell align="center">{row.KPICalculation}</TableCell>

                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>
        ))}
      </TabContext>
    </>
  );
};

export default ResultDeepdive;
